'use client';

import { c as _c } from "react/compiler-runtime";
import React, { type ComponentProps } from 'react';
import { usePathname } from 'next/navigation';
import { UmamiScript } from '@repo/ui/umami-script';

/**
 * `/r/<token>` is a shared analytics report (#1366): the path segment is a
 * bearer credential. The analytics beacon records page URLs, so it must never
 * load there. Matches `/r/...` only — not `/r`, `/reports`, or anything else.
 */
export function isSharedReportPath(pathname: string | null | undefined): boolean {
  return typeof pathname === 'string' && pathname.startsWith('/r/');
}

/**
 * Renders the Umami script everywhere except shared-report pages. Gating here,
 * in the root layout, keeps tracking on every other public page (`/`,
 * sign-in, sign-up, accept-token, …) — moving the script into the
 * `(dashboard)` layout would have dropped those.
 *
 * A shared report is always a full page load (the link is pasted, never an
 * in-app `<Link>`), so the script is never already loaded when `/r/*` renders.
 */
export function UmamiGate(props) {
  const $ = _c(2);
  const pathname = usePathname();
  if (isSharedReportPath(pathname)) {
    return null;
  }
  let t0;
  if ($[0] !== props) {
    t0 = <UmamiScript {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}